// Copyright (C) 2020 TANNER AG

import { graphql } from 'react-apollo'
import { compose } from 'recompose'
import withLocalization from './withLocalization'
import withFlattenedTranslations from './withFlattenedTranslations'
import withLoadingState from './withLoadingState'
import withErrorState from './withErrorState'
import withConnectionStatus from './withConnectionStatus'
import podcastQuery from '../queries/podcast'

const buildQueryOptions = ({
    id,
    language,
    fetchPolicy,
    stage
}) => {
    return {
        variables: {
            id,
            stage,
            lang: language.toLowerCase(),
        },
        fetchPolicy
    }
}

export default customLoadingComponent =>
    compose(
        withConnectionStatus,
        withLocalization,
        graphql(podcastQuery, {
            options: props => {
                return buildQueryOptions(props)
            }
        }),
        withErrorState,
        withLoadingState('podcast', customLoadingComponent, customLoadingComponent),
        withFlattenedTranslations('podcast'),
    )



// WEBPACK FOOTER //
// ./src/hocs/withPodcast.js